export default __webpack_public_path__ + "static/media/Campo.16f6a463.jpg";